/**
 * NINETEENSTARZ add-to-cart star burst.
 *
 * Purely decorative, purely additive: watches for the native `data-added="true"`
 * state that assets/product-form.js already sets on an add-to-cart button after
 * a real, successful add (see animateAddToCart() there) and, only for buttons
 * inside our product cards, scatters a handful of small star shapes from the
 * button. No cart/variant/form logic is touched or duplicated - this only
 * reacts to a state Shopify's own code already confirms.
 *
 * Respects prefers-reduced-motion by not running at all.
 */
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!prefersReducedMotion) {
  const STAR_COUNT = 6;
  const BURST_DURATION_MS = 700;

  /** @param {HTMLElement} button */
  function spawnBurst(button) {
    const rect = button.getBoundingClientRect();
    const originX = rect.left + rect.width / 2;
    const originY = rect.top + rect.height / 2;

    for (let i = 0; i < STAR_COUNT; i += 1) {
      const angle = (Math.PI * 2 * i) / STAR_COUNT + Math.random() * 0.5 - 0.25;
      const distance = 36 + Math.random() * 28;
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance - 18;

      const star = document.createElement('span');
      star.className = 'ns-star-particle';
      star.setAttribute('aria-hidden', 'true');
      star.style.setProperty('--ns-star-x', `${originX}px`);
      star.style.setProperty('--ns-star-y', `${originY}px`);
      star.style.setProperty('--ns-star-dx', `${dx}px`);
      star.style.setProperty('--ns-star-dy', `${dy}px`);
      star.style.setProperty('--ns-star-delay', `${i * 22}ms`);

      document.body.appendChild(star);
      star.addEventListener('animationend', () => star.remove());
      // Safety net in case animationend doesn't fire (e.g. tab backgrounded).
      setTimeout(() => star.remove(), BURST_DURATION_MS + STAR_COUNT * 22 + 300);
    }
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'data-added') continue;

      const button = mutation.target;
      if (!(button instanceof HTMLElement)) continue;
      if (button.dataset.added !== 'true') continue;
      if (!button.classList.contains('add-to-cart-button')) continue;
      if (!button.closest('.product-grid__card')) continue;

      spawnBurst(button);
    }
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-added'],
    subtree: true,
  });
}
